import { ReactElement } from 'react';
import classNames from 'classnames';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './styles';

export interface DialogTitleProps {
  children: React.ReactNode;
  isDraggable: boolean;
  titleClassName?: string;
  onClose: () => void;
}

const ModalTitle = ({
  children,
  isDraggable,
  titleClassName = '',
  onClose,
}: DialogTitleProps): ReactElement => {
  const classes = useStyles();
  const isTextTitle = typeof children === 'string' || typeof children === 'number';

  return (
    <MuiDialogTitle
      disableTypography
      className={classNames(classes.root, titleClassName)}
      style={{ cursor: isDraggable ? 'move' : '' }}
      id={isDraggable ? 'draggable-dialog-title' : ''}
    >
      {isTextTitle ? <Typography variant="h6">{children}</Typography> : children}
      <IconButton aria-label="close" onClick={onClose} className={classes.closeButton}>
        <CloseIcon />
      </IconButton>
    </MuiDialogTitle>
  );
};

export default ModalTitle;
